import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Switch } from '@headlessui/react';

const useStyles = makeStyles(() => ({
  root: {
    width: 42,
    height: 42,
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',

    '&.checked': {
      '& .strip': {
        backgroundColor: 'var(--color-toggle-strip-active-color)',
      },

      '& .pill': {
        backgroundColor: 'var(--color-colorPrimary-main)',
        left: 'initial',
        right: 0,
        borderColor: 'var(--color-colorPrimary-main)',
      },
    },

    '& .strip': {
      height: 14,
      width: 42,
      backgroundColor: 'var(--color-toggle-strip-color)',
      borderRadius: 7,
    },

    '& .pill': {
      width: 20,
      height: 20,
      backgroundColor: 'var(--color-white-alt)',
      borderRadius: '50%',
      position: 'absolute',
      left: 0,
      border: '1px solid var(--color-toggle-border-color)',
    },
  },
}));

const Toggle = ({ onChange, checked }) => {
  const classes = useStyles();

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={`${classes.root} ${checked ? 'checked' : ''}`}
    >
      <div className="strip"></div>
      <span className={`pill`} />
    </Switch>
  );
};

export default Toggle;
